import React, { useEffect, useState } from "react";
import { Col, Input, Row, Select, Button } from "antd";
import AppInput from "../../../../components/AppInput";
import moment from "moment";
import VoyageDetails from "../../../../components/VoyageDetails";
import { post } from "../../../../services/services";
import { ApiURL } from "../../../../services/apiConstants";
import { useParams } from "react-router-dom";
import { fuelTypeOptions } from "../../../../Data/data";

const { Option } = Select;

const ViewBunkerDetails = () => {
  const { bunker_id } = useParams();
  const [staffDashboard, setStaffDashboard] = useState("");
  const [subTankList, setSubTankList] = useState([]);
  const [submitStatus, setSubmitStatus] = useState(false);
  const [softDelete, setSoftDelete] = useState("");

  // ✅ initialize with tanks array
  const [form, setForm] = useState({
    bunkerDate: moment().format("YYYY-MM-DD"),
    bdnReferenceNo: "",
    bunkeringLocation: "",
    supplierName: "",
    chartererOrOwner: "",
    bargeNameAndImo: "",
    grade: "",
    density: "",
    sulphur: "",
    chiefEngSign: "",
    totalquantity: "",
    tanks: [{ tankId: null, quantity: "" }],
  });

  // fetch tanks list
  const listSubTanks = async () => {
    const staffDetails = JSON.parse(localStorage.getItem("user_data"));
    try {
      const formData = new FormData();
      formData.append("ship_id", staffDetails?.data?.ship_details?.ship_id);
      const res = await post(ApiURL?.bunker_report_list, formData);
      if (res?.status === true) {
        setSubTankList(res?.tanks);
      }
    } catch (err) {
      console.error("Error fetching Sub Tanks list:", err);
    }
  };

  // view bunker details
  const viewBunkerDetails = async (voyageData) => {
    try {
      const formData = new FormData();
      formData.append("voyage_id", voyageData?.voyage_details?.[0]?.id);
      formData.append("record_id", atob(bunker_id));
      formData.append("request_type", "view");

      const res = await post(ApiURL.update_bunker_details_st_bd, formData);
      if (res?.status === true) {
        const { data } = res;

        setForm({
          bunkerDate: data?.bunker_date || moment().format("YYYY-MM-DD"),
          bdnReferenceNo: data?.bdn_reference_no || "",
          bunkeringLocation: data?.bunkering_location || "",
          supplierName: data?.supplier_name || "",
          chartererOrOwner: data?.charterer_or_owner || "",
          bargeNameAndImo: data?.barge_name_and_imo || "",
          grade: data?.grade || "",
          density: data?.density || "",
          sulphur: data?.sulphur || "",
          chiefEngSign: data?.chief_eng_sign || "",
          totalquantity: data?.totalquantity || "",
          tanks: Array.isArray(data?.tanks)
            ? data.tanks
            : [{ tankId: null, quantity: "" }],
        });

        setSubmitStatus(data?.submit_status);
        setSoftDelete(data?.soft_delete);
      }
    } catch (err) {
      console.error("Error fetching bunker details:", err);
    }
  };

  useEffect(() => {
    const staffDashboards = localStorage.getItem("staff_dashboard");
    const parsedData = staffDashboards ? JSON.parse(staffDashboards) : null;

    if (parsedData) {
      setStaffDashboard(parsedData);
      viewBunkerDetails(parsedData);
      listSubTanks();
    }
  }, []);

  return (
    <>
      <VoyageDetails staff_dashboard={staffDashboard?.voyage_details} />
      <div className="white-container">
        <h3>View Bunker Record</h3>
        <br />

        {/* First row */}
        <div className="row">
          <div className="col-6">
            <AppInput
              disabled
              type="date"
              label="Bunker Date"
              value={form.bunkerDate}
            />
          </div>
          <div className="col-6">
            <AppInput
              disabled
              label="BDN Reference No."
              value={form.bdnReferenceNo}
            />
          </div>
        </div>

        {/* Second row */}
        <div className="row">
          <div className="col-6">
            <AppInput
              disabled
              label="Bunkering Location"
              value={form.bunkeringLocation}
            />
          </div>
          <div className="col-6">
            <AppInput
              disabled
              label="Name of the Supplier"
              value={form.supplierName}
            />
          </div>
        </div>

        {/* Third row */}
        <div className="row">
          <div className="col-6">
            <AppInput
              disabled
              label="Bunker Supplied by Charterer/Owner"
              value={form.chartererOrOwner}
            />
          </div>
          <div className="col-6">
            <AppInput
              disabled
              label="Barge Name details / IMO No."
              value={form.bargeNameAndImo}
            />
          </div>
        </div>

        {/* Fourth row */}
        <div className="row">
          <div className="col-6">
            <label className="form-label">Grade</label>
            <Select
              disabled
              value={form.grade}
              style={{ width: "100%" }}
              placeholder="Select Fuel Grade"
              options={fuelTypeOptions}
            />
          </div>
          <div className="col-6">
            <AppInput
              disabled
              label="Density at 15°C (Kg/m³)"
              value={form.density}
            />
          </div>
        </div>

        {/* Fifth row */}
        <div className="row">
          <div className="col-6">
            <AppInput
              disabled
              label="Sulphur (%m/m)"
              value={form.sulphur}
            />
          </div>
          <div className="col-6">
            <AppInput
              disabled
              label="Total Quantity (MT)"
              value={form.totalquantity}
            />
          </div>
        </div>

        {/* Sixth row */}
        <div className="row">
          <div className="col-6">
            <AppInput
              disabled
              label="Chief Eng. Name & Sign"
              value={form.chiefEngSign}
            />
          </div>
        </div>

        {/* Tanks Section */}
        <div className="mt-3 input-box p-3">
          {form.tanks.map((tank, index) => (
            <Row gutter={16} key={index} style={{ marginBottom: 16 }}>
              <Col span={12}>
                <label className="form-label">Tank No.</label>
                <Select
                  disabled
                  value={tank.tankId}
                  style={{ width: "100%" }}
                  placeholder="Select Tank"
                >
                  {subTankList?.map((t) => (
                    <Option key={t.id} value={t.id}>
                      {`${t.id} - ${t.category_name} (${
                        t.fuel_type || "No fuel"
                      })`}
                    </Option>
                  ))}
                </Select>
              </Col>
              <Col span={12}>
                <label className="form-label">Quantity (MT)</label>
                <Input
                  disabled
                  type="number"
                  value={tank.quantity}
                  placeholder="Enter Quantity"
                />
              </Col>
            </Row>
          ))}
        </div>
      </div>
    </>
  );
};

export default ViewBunkerDetails;
